<template>
    <div v-show="show" class="bg">
        <div class="box-container">
            <div class="title">
                <p>视频打标</p>
            </div>
            <div class="tag selectTag">
                <div class="title red">
                    <p>必选标签</p>
                    <i>(选择一个)</i>
                </div>
                <div class="tagList">
                    <p v-for="(item,index) in requiredList" :key="index" @click="selectRequired(item)" :class="{on: item.selected}">{{item.name}}</p>
                </div>
            </div>
            <div class="tag selectTag">
                <div class="title un">
                    <p>可选标签</p>
                    <i>(选填，选择一个)</i>
                </div>
                <div class="tagList">
                    <p v-for="(item,index) in optionalList" :key="index" @click="selectOptional(item)" :class="{on: item.selected}">{{item.name}}</p>
                </div>
            </div>
            <div class="btns-container">
                <p @click="submitTag" class="btn on">确定</p>
                <p @click="close" class="btn">取消</p>
            </div>
        </div>
    </div>
</template>

<script>
    import { REQUIRED_TAGS, OPTIONAL_TAGS } from "./constants";

    export default {
        data() {
            return {
                show: false,
                c: null,
                requiredList: [],
                optionalList: []
            }
        },
        methods: {
            // 单选：点击同组内其他标签时清除已选
            selectRequired(item) {
                this.requiredList.forEach(el => {
                    el.selected = false
                })
                item.selected = true
            },
            selectOptional(item) {
                // 允许取消选择
                if (item.selected) {
                    item.selected = false
                } else {
                    this.optionalList.forEach(el => {
                        el.selected = false
                    })
                    item.selected = true
                }
            },
            open(res, c) {
                const info = res || {}
                // 优先使用接口返回的 labeling_info 标签库（label_name 字段），缺省时回退静态常量（name 字段）
                if (info.required_label_list && info.required_label_list.length) {
                    this.requiredList = info.required_label_list.map(el => ({ ...el, name: el.label_name, selected: false }))
                } else {
                    this.requiredList = REQUIRED_TAGS.map(el => ({ ...el, selected: false }))
                }
                if (info.optional_label_list && info.optional_label_list.length) {
                    this.optionalList = info.optional_label_list.map(el => ({ ...el, name: el.label_name, selected: false }))
                } else {
                    this.optionalList = OPTIONAL_TAGS.map(el => ({ ...el, selected: false }))
                }

                // 回显已选
                if (info.required_label_ids && info.required_label_ids.length) {
                    const id = info.required_label_ids[0]
                    const target = this.requiredList.find(el => el.id === id || el.id === Number(id))
                    if (target) target.selected = true
                }
                if (info.optional_label_ids && info.optional_label_ids.length) {
                    const id = info.optional_label_ids[0]
                    const target = this.optionalList.find(el => el.id === id || el.id === Number(id))
                    if (target) target.selected = true
                }

                this.c = c
                this.show = true
            },
            close() {
                this.show = false
                this.c(false)
            },
            submitTag() {
                const requiredSel = this.requiredList.find(el => el.selected)
                const optionalSel = this.optionalList.find(el => el.selected)

                if (!requiredSel) {
                    this.$toast('请选择必选标签')
                    return
                }

                this.c({
                    required_label_ids: [requiredSel.id],
                    optional_label_ids: optionalSel ? [optionalSel.id] : [],
                    required_label_name: requiredSel.name,
                    optional_label_name: optionalSel ? optionalSel.name : ''
                })
                this.show = false
            }
        }
    }
</script>

<style lang="less" scoped>
@import "../../assets/css/global.less";
.bg {
    position: relative;
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    background: rgba(50, 59, 75, 0.3);
    backdrop-filter: blur(1.6px);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100000000;

    .box-container {
        width: 760px;
        min-height: 372px;
        padding: 20px 30px 24px;
        background: #F9F9F9;
        border-radius: 4px;
        box-sizing: border-box;

        &>.title {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            margin-bottom: 20px;

            p {
                font-size: 24px;
                color: #323B4B;
                line-height: 33px;
                font-weight: bold;
            }
        }

        .tag {
            display: flex;
            flex-direction: row;
            width: 100%;

            &.selectTag {
                align-items: baseline;
                .tagList {
                    border-bottom: 1px solid #F0F0F0;
                    box-sizing: border-box;
                }
            }

            .title {
                position: relative;
                display: flex;
                flex-direction: column;
                font-size: 14px;
                color: #666;
                min-width: 81px;
                margin-top: 5px;

                i {
                    font-size: 12px;
                    color: #829191;
                }

                &.red {
                    &::before {
                        position: absolute;
                        top: -10px;
                        left: -10px;
                        display: block;
                        content: '*';
                        font-size: 24px;
                        color: #FF555A;
                    }
                }

                &.un {
                    &::before {
                        position: absolute;
                        top: -10px;
                        left: -10px;
                        display: block;
                        content: '';
                        font-size: 24px;
                    }
                }
            }

            .tagList {
                display: flex;
                flex-direction: row;
                flex-wrap: wrap;
                flex: 1;
                margin-bottom: 20px;

                p {
                    height: 30px;
                    line-height: 30px;
                    border-radius: 20px;
                    padding: 0 26px;
                    border: 1px solid #829191;
                    box-sizing: border-box;
                    font-size: 14px;
                    color: #829191;
                    margin: 0 10px 20px 0;
                    user-select: none;
                    cursor: pointer;

                    &.on {
                        color: @green;
                        border: 1px solid @green;
                        box-sizing: border-box;
                        font-weight: bold
                    }
                }
            }
        }
        .btns-container {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            width: 100%;
            margin-top: 24px;

            .btn {
                width: 120px;
                height: 32px;
                background: #B9C3C3;
                border-radius: 4px;
                font-size: 14px;
                line-height: 32px;
                font-weight: bold;
                text-align: center;
                color: #FFF;
                user-select: none;
                cursor: pointer;

                &.on {
                    background: #41B48C;
                    margin-right: 20px;
                }
            }
        }
    }
}
</style>
